module.exports = __webpack_public_path__ + "img/Group3.aedb62ab.png";